'use client';
import { useEffect, useState } from 'react';

import { useSearchParams } from '@/hooks';

import { connectHubspot } from '@/services/my';
export default function Page() {
  const { code } = useSearchParams();

  const [text, setText] = useState('');
  useEffect(() => {
    if (code) {
      const redirectUri = window.location.origin + '/callback/hubspot';
      connectHubspot({ code, redirectUri }).then((res) => {
        if (res.id) {
          setText('bind success');
        }
      });
    }
  }, [code]);
  return <div>{text}</div>;
}
